import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  customRoot: {},
  modalContainer: {
    padding: '',
  },
  modalTitle: {
    padding: '0px 24px',
  },
  dialogContent: {
    fontFamily: 'Poppins',
    textAlign: 'center',
    //padding: '0px 48px 24px 48px',
  },
  dialogContainer: {
    borderRadius: '16px',
  },
  paper: {
    margin: 0,
    width: 840,
    padding: '48px',
    borderRadius: 16,
    overflowX: 'hidden',
  },
  actionButtons: {
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
}));
